export const RESTART_STATE = 'precios/basedatos/restart_state';
export const SET_MASK = 'precios/basedatos/set-mask';
export const UPDATE_FIELD_FILTER = 'precios/basedatos/update-field-filter';
export const RECEIVE_V_LIST = 'precios/basedatos/receive-v-list';
export const SET_ORDER = 'precios/basedatos/set-order';
